export function readSessionUser() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user && typeof user === 'object' ? user : null;
  } catch {
    return null;
  }
}

export function roleLabel(tipo) {
  if (tipo === 'admin') return 'Administrador';
  if (tipo === 'gerente') return 'Gerente';
  if (tipo === 'funcionario') return 'Funcionário';
  return tipo ? String(tipo) : 'Sessão autenticada';
}

export function organizationLabel(user) {
  if (!user) return null;
  const named = user.organizacao_nome || user.organization?.nome || user.organizacao?.nome;
  if (named) return String(named);
  if (user.organizacao_id) return `Organização ${user.organizacao_id}`;
  return null;
}

export function canSeeManagerNavigation(user) {
  if (!user?.tipo) return true;
  return user.tipo === 'admin' || user.tipo === 'gerente';
}

export function canReviewApprovals(user) {
  return user?.tipo === 'admin';
}

export function accessPresentation(user) {
  if (user?.approval_status === 'pending') {
    return { status: 'pendente', label: 'Aguardando aprovação' };
  }
  if (user?.approval_status === 'rejected') {
    return { status: 'rejeitado', label: 'Rejeitado' };
  }
  if (user?.ativo === 0 || user?.ativo === false) {
    return { status: 'rejeitado', label: 'Inativo' };
  }
  return { status: 'ativo', label: 'Ativo' };
}
